// import { ILanguage } from '../../types/ILanguage'
// qs could be used, as mentioned in https://docs.strapi.io/dev-docs/api/rest/sort-pagination


export const APIGetPanellists = () => {
  const url = '/panelists' +
    `?populate[image][populate]=*` +
    `&populate[localizations]=*`
    

  return url
}

export const APIGetMedallists = () => {
  const url = '/medallists' +
    `?populate[profileImage][populate]=*` +
    `&populate[medallistPhaseOneDotFiveImage][populate]=*` +
    `&populate[medallistPhaseTwoImage][populate]=*` +
    `&populate[medallistPhaseTwoDotFiveImage][populate]=*` +
    `&pagination[page]=1&pagination[pageSize]=99`
    

  return url
}
